<template>
  <section class="faq-section">
    <h2 class="section-title">问题解答</h2>
    <div class="faq-list">
      <div
        v-for="(item, index) in faqList"
        :key="index"
        class="faq-item"
        :class="{ expanded: activeIndex === index }"
      >
        <div class="faq-question" @click="toggle(index)">
          <span>{{ item.question }}</span>
          <span class="chevron" :class="{ up: activeIndex === index }" />
        </div>
        <div v-show="activeIndex === index" class="faq-answer">
          {{ item.answer }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: -1,
      faqList: [
        {
          question: "如何获得金色，银色，铜色卡牌?",
          answer:
            "通过参与盲盒板块，使用RAD代币购买对应等级的盲盒，即可随机获得金色、银色或铜色卡牌。",
        },
        {
          question: "如何参与质押挖矿?",
          answer:
            "点击RUSD奖励板块的「立即参与」按钮，进入质押页面，选择质押方案并完成RAD代币质押即可开始挖矿。",
        },
        {
          question: "卡牌的权益?",
          answer:
            "金色卡牌可获得团队收益的0.5%，银色卡牌可获得团队收益的0.3%，铜色卡牌可获得团队收益的0.1%。",
        },
      ],
    };
  },
  methods: {
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? -1 : index;
    },
  },
};
</script>

<style lang="scss" scoped>
.faq-section {
  padding: 50px 30px 30px;
}

.section-title {
  margin: 0 0 30px;
  font-size: 50px;
  font-weight: normal;
  color: #fff;
}

.faq-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.faq-item {
  border-radius: 24px;
  background: #040a28;
  border: 1px solid rgba(115, 56, 255, 0.2);
  overflow: hidden;
}

.faq-question {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px;
  font-size: 26px;
  color: #fff;
  cursor: pointer;
  user-select: none;

  .chevron {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    border-right: 2px solid #fff;
    border-bottom: 2px solid #fff;
    transform: rotate(45deg);
    transition: transform 0.2s;

    &.up {
      transform: rotate(-135deg);
    }
  }
}

.faq-answer {
  padding: 0 30px 30px;
  font-size: 26px;
  line-height: 1.7;
  color: #C0C0C0;
}
</style>
